/**
 * parentRoutes — TabKey ↔ React Navigation route names for the parent shell.
 * Single map so ParentTabBar and deep-link helpers stay aligned.
 */
import { type TabKey } from "../../../../../design-system"

export const PARENT_TAB_KEY_TO_ROUTE: Record<
    Extract<TabKey, "parentHome" | "parentActivities" | "parentReports" | "parentSubscription">,
    string
> = {
    parentHome: "parent-home",
    parentActivities: "parent-activities",
    parentReports: "parent-reports",
    parentSubscription: "parent-subscription",
}

export const PARENT_ROUTE_TO_TAB_KEY: Record<string, TabKey> = {
    "parent-home": "parentHome",
    "parent-activities": "parentActivities",
    "parent-reports": "parentReports",
    "parent-subscription": "parentSubscription",
}

export function tabKeyToRouteName(key: TabKey): string | undefined {
    return (PARENT_TAB_KEY_TO_ROUTE as Partial<Record<TabKey, string>>)[key]
}

export function routeNameToTabKey(routeName: string): TabKey {
    return PARENT_ROUTE_TO_TAB_KEY[routeName] ?? "parentHome"
}
